/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Link, SimpleGrid } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
// import StructuredTextContent from '@components/UI/StructuredTextContent';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain, refreshPage } from '@components/Utility/utils';
import { Styles } from '../../constants';

/* Services */

/**
 * Renders the Card Info 3 Card component
 * @param {Object} sectionContent - Data for section
 * @param {string} region - Region of the page
 * @param {string} lang - Language of the page
 * @param isLeftMenu - responsive navbar for the page
 * @returns {ReactElement} Card Info 3 Card component
 */

const SankalpaCardInfo3 = ({ sectionContent, region, lang, isLeftMenu, pageConfig }) => {
  // const bgColors = ['#cd6727', '#ae4511', '#10069f'];
  const bgColors = Styles.bgColors;
  const pName = pageConfig?.pageName;
  // console.log("the page name is", pName)
  return (
    <Box
      mx="auto"
      maxW={{
        base: '302px',
        sm: '480px',
        md: '690px',
        lg: '770px',
        xl: '900px',
      }}
    >
      <SimpleGrid
        gridRowGap={{ base: '15px', lg: '30px' }}
        columns={{
          base: 1,
          md: 2,
          lg:  2,
          xl: sectionContent?.cards?.length,
        }}
        spacing={{base:"4px",md:"10px"}}
        mx="auto"
        mt={"30px"}
      >
        {sectionContent?.cards?.map((secCon, index) => {
          
          return (
            <Box
              id="card3"
              key={nanoid()}
              display="flex"
              flexDirection="column"
              mx="auto"
              w={{
                base: '100%',
                sm: '330px',
                // lg: '370px',
                lg:'380px'
                  
              }}
              position="relative"
              mb={'20px'}
            >
              
               
              {secCon.thumbnail?.url != null && (
               
                  <Link
                    position="relative"
                    zIndex="1"
                    cursor={secCon.buttonLink ? 'cursor' : 'auto'}
                    onClick={e => refreshPage(e?.target?.href, e)}
                  >
                    <LazyLoadImageComponent
                      src={secCon.thumbnail?.url}
                      alt={secCon.thumbnail?.alt}
                      title={secCon.thumbnail?.title}
                      objectFit="cover"
                    //   w="100%"
                    //   minH="210px"
                      height={{base:"170px",md:"198px",lg:'285px' }}
                      width={{base:"285px",md:"325px",lg:'468.95px'}}
                      mt={{base:"-1px",md:"7px"}}
                    />
                    <Box
                      w={{base:"78%",md:"88.3%"}}
                      h={{
                        base: '198px',
                        md: '225px',
                        lg: '320px' ,
                      }}
                      position="absolute"
                      left="21.65px"
                      backgroundImage={
                        `url('https://www.datocms-assets.com/46272/1733821310-columninfo3bg.png')`
                      } 
                      backgroundSize="cover" // Ensures the image covers the entire box
                      backgroundPosition="center" // Centers the image
                      outline="1px solid transparent"
                      zIndex="-1"
                      top={{ base: '-15px', md: '-8px', xl: '-10px' }}
                    />
                  </Link>
              )}
              <Box
                m={{
                  base: '0 4px',
                  md:'0 18px',
                }}
              >
                <Box
                  lineHeight={{base:"30.24px",md:"27.2px",xl: '30.24px'}}
                  fontFamily={
                   
                       'Fedra Serif Display'
                      
                  }
                  fontSize={{base:"24px",md:"20px",xl:'24px'}}
                  mt="35px"
                  color={'#081B5C' }
                  fontWeight={'700'}
                >
                  {secCon.title}
                </Box>
                <Box
                  fontFamily="FedraSansStd-book"
                  fontSize={'18px'}
                  lineHeight={{base:'28.8px',md:"25.2px"}}
                  color={'#1F1F1F'}
                  pt={15}
                >
                  <StructuredTextParser
                    str={render(secCon.description)}
                    region={region}
                    lang={lang}
                    fontSize={{base:"18px",md:"16px",xl:"20px"}}
                    mt="0"
                    className="link-text"
                  />
                </Box>
              </Box>
              <style global jsx>
                {`
                  #card3 a {
                    color: #cf4824;
                  }
                  #card3 a:hover {
                    color: #ffffff;
                  }
                  .link-text p a {
                    color: #28231e !important;
                    word-break: break-word;
                    border-bottom: 2px solid #cf4824;
                    transition: background-size 0.125s ease-in;
                    background-image: linear-gradient(120deg, #cf4824, #cf4824);
                    background-repeat: no-repeat;
                    background-size: 100% 0;
                    background-position: 0 100%;
                  }

                  .link-text p a:hover {
                    background-color: #cf4824;
                    color: white !important;
                    background-image: linear-gradient(120deg, #cf4824, #cf4824);
                    background-size: 100% 100%;
                    transition: all 0.3s ease-in-out;
                  }
                `}
              </style>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box >
  );
};

export default SankalpaCardInfo3;